import { render, staticRenderFns } from "./AlertManagement.vue?vue&type=template&id=2a10db16&"
import script from "./AlertManagement.vue?vue&type=script&lang=js&"
export * from "./AlertManagement.vue?vue&type=script&lang=js&"
import style0 from "./AlertManagement.vue?vue&type=style&index=0&id=2a10db16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QDialog})
